import React from 'react';
import styled, { css, keyframes } from 'styled-components';

type ChipProps = {
  name: string;
  device?: string;
  emergency?: boolean;
  className?: string;
};

const popIn = keyframes`
  from { opacity: 0; transform: translateY(-6px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

const Chip = styled.div<{ $emergency?: boolean }>`
  background: ${({ $emergency }) => ($emergency ? '#B91C1C' : 'rgba(255, 255, 255, 0.9)')};
  color: #020202ff;
  border-radius: 12px;
  padding: 10px 12px;
  width: 280px;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.35);
  pointer-events: none;
  animation: ${popIn} 140ms ease-out both;

  /* Optional theming hook */
  ${({ theme }) =>
    theme?.inCallChip &&
    css`
      ${theme.inCallChip}
    `}
`;

const Caption = styled.div`
  font-size: 11px;
  opacity: 0.8;
  margin-bottom: 2px;
`;

const Name = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Device = styled.div`
  font-size: 12px;
  opacity: 0.9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InCallQueueChip: React.FC<ChipProps> = ({ name, device, emergency, className }) => {
  return (
    <Chip className={className} $emergency={!!emergency} role="status" aria-live="polite">
      <Caption>Incoming call request{emergency ? ' • EMERGENCY' : ''}</Caption>
      <Name>{name}</Name>
      {device && <Device>{device}</Device>}
    </Chip>
  );
};
